/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {IImmortalFruitsInitData, IImmortalFruitsServerData} from "./data/IImmortalFruitsServerData";
import {SpinServerDataParser} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinServerDataParser";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";

export class ImmortalFruitsServerDataParser extends SpinServerDataParser {

    constructor() {
        super();
    }
    public parseWheelOneValues(rawData: IImmortalFruitsServerData): number[] {
        return rawData.wheelOneValues;
    }
    public parseWheelTwoValues(rawData: IImmortalFruitsServerData): number[] {
        return rawData.wheelTwoValues;
    }
    public parseWheelThreeValues(rawData: IImmortalFruitsServerData): number[] {
        return rawData.wheelThreeValues;
    }
    public parseTotalWheelTimesBetCollected(rawData: IImmortalFruitsServerData): number {
        return rawData.totalWheelTimesBetCollected;
    }
    public parseTotalWheelTimesBetCollectedAfter(rawData: IImmortalFruitsServerData): number {
        return rawData.totalWheelTimesBetCollectedAfter;
    }
    public parseTotalWheelTimesBetCollectedBefore(rawData: IImmortalFruitsServerData): number {
        return rawData.totalWheelTimesBetCollectedBefore;
    }
    public parseWheelLevel(rawData: IImmortalFruitsServerData): number{
        return rawData.wheelLevelBefore;
    }
    public parseWheelLevelInit(rawData: IImmortalFruitsServerData): number{
        return rawData.wheelLevel;
    }
    public parseGambleCollection(rawData: IImmortalFruitsServerData): boolean{
        return rawData.gambleCollect;
    }
    public parseLandedWheelIndex(rawData: IImmortalFruitsServerData): number{
        return rawData.landedWheelIndex;
    }
    public parseLevelPositionsTakenAfter(rawData: IImmortalFruitsServerData): boolean[] {
        return rawData.levelPositionsTakenAfter;
    }
    public parseLevelPositionsTaken(rawData: IImmortalFruitsServerData): boolean[] {
        return rawData.levelPositionsTaken;
    }
    public parseGambleOptionPicked(rawData:IImmortalFruitsServerData):number{
        return rawData.gambleOptionPicked;
    }
    public parseBetWinsInit(rawData: IImmortalFruitsInitData): IBetLineWinData[] | IBetWayWinData[] | undefined {
        switch (ImmortalFruitsGameConfig.instance.BET_WIN_MODE) {
            case 1 /* BET_LINE */
            :
                return rawData.betLineWins;
            case 2 /* BET_WAY */
            :
                return rawData.betWayWins;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public getEvaluatedArea(rawData : IImmortalFruitsServerData){
        return rawData.evaluatedArea;
    }


}